<mat-toolbar class="page-header">
  <div class="menu-container">
    <button backPage class="pg-header-btn" mat-icon-button>
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="pg-title">
      Policy details ({{ details?.policyRefNo || "-" }})
    </div>
  </div>
</mat-toolbar>

<div class="content-container md">
  <div [ngSwitch]="details?.UI_status" class="pt-sm pb-sm" fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayout="row">
      <div>
        <span class="cover-label lg" [ngClass]="getPolicyStatusCss(details?.UI_status)">
          {{ details?.UI_status }}
        </span>
      </div>
      <div class="ml-md label-f">
        Created on
        {{ details?.createdDate | date : "dd MMM yyyy hh:mm aa" || "-" }}
      </div>
    </div>
  </div>
  <mat-card class="card-details">
    <div class="card-title-container-2 space-between">
      <div class="title-f">Customer Details</div>
    </div>
    <mat-divider></mat-divider>
    <div class="row-content">
      <div>
        <span class="label-f">Name</span>
        <span [copyValue]="details?.fullName" class="value-f">
          {{ details?.fullName || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Identity No. / Passport No.</span>
        <span [copyValue]="details?.identityNo" class="value-f">
          {{ details?.identityNo || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Mobile No.</span>
        <span [copyValue]="details?.mobileNo" class="value-f">
          {{ details?.mobileNo || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Email</span>
        <span [copyValue]="details?.email" class="value-f">
          {{ details?.email || "-" }}
        </span>
      </div>
    </div>
  </mat-card>
  <mat-card class="card-details">
    <div class="card-title-container-2">
      <div class="title-f">Policy Information</div>
    </div>
    <mat-divider></mat-divider>
    <div class="row-content">
      <div>
        <span class="label-f">Product Type</span>
        <span [copyValue]="details?.UI_productType" class="value-f">
          {{ details?.UI_productType || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Purchase Date</span>
        <span [copyValue]="details?.purchaseDate" class="value-f">
          {{ details?.purchaseDate | date: "dd MMM yyyy" || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Coverage Period</span>
        <span class="value-f" [copyValue]="
               ( details?.startDate
                  | date : 'dd MMM yyyy') + '-' + (details?.endDate
                  | date : 'dd MMM yyyy')
              ">
          {{ details?.startDate | date : "dd MMM yyyy" || "-" }}
          -
          {{ details?.endDate | date : "dd MMM yyyy" || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Policy Ref No.</span>
        <span [copyValue]="details?.policyRefNo" class="value-f">
          {{ details?.policyRefNo || "-" }}
        </span>
      </div>
      <div *ngIf="details.productType === 'TP'">
        <span class="label-f">Destination</span>
        <span [copyValue]="details?.UI_destination" class="value-f">
          {{ details?.UI_destination || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Duration</span>
        <span class="value-f" [copyValue]="details?.duration">
          <ng-container *ngIf="details?.duration && details?.productType === 'TP'; else elseBlock">{{ details?.duration || "-" }} Day(s)</ng-container>
          <ng-template #elseBlock><ng-container>1 month</ng-container></ng-template>
        </span>
      </div>
      <div>
        <span class="label-f">Premium</span>
        <span class="value-f" [copyValue]="details?.premium">
          {{ (details?.premium | currency : "RM") || "-" }}
        </span>
      </div>
      <div>
        <span class="label-f">Premium Paid</span>
        <span class="value-f" [copyValue]="details?.premiumTotal">
          {{ (details?.premiumTotal | currency : "RM") || "-" }}
        </span>
      </div>
    </div>
  </mat-card>

  <mat-card style="margin-bottom: -5px !important">
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div class="pg-title ph-sm">Claim List</div>
      <div>
        <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
          <input (ngModelChange)="searchChanged()" [(ngModel)]="searchText" autocomplete="off" matInput
            placeholder="Search reference no." />
        </mat-form-field>

        <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
          <mat-select (ngModelChange)="selectedStatusList = $event; filter()" [ngModel]="selectedStatusList" multiple>
            <mat-select-trigger>
              {{ getStatusDisplay() }}
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search (ngModelChange)="filterStatusSelection($event)"
                (toggleAll)="toggleSelectAllStatus($event)" [ngModelOptions]="{ standalone: true }"
                [searching]="!statusList.length" [showToggleAllCheckbox]="true"
                [toggleAllCheckboxChecked]="isSelectedAllStatus()"
                [toggleAllCheckboxIndeterminate]="isIndeterminateStatus()" ngDefaultControl ngModel
                noEntriesFoundLabel="No matching status found" placeholderLabel="Search Status...">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let item of filterStatusList" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
          <button (click)="resetStatus()" *ngIf="!isSelectedAllStatus()" class="clear-field-btn" mat-icon-button
            matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
          <mat-select (ngModelChange)="selectedTypeList = $event; filter()" [ngModel]="selectedTypeList" multiple>
            <mat-select-trigger>
              {{ getTypeDisplay() }}
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search (ngModelChange)="filterTypeSelection($event)"
                (toggleAll)="toggleSelectAllType($event)" [ngModelOptions]="{ standalone: true }"
                [searching]="!typeList.length" [showToggleAllCheckbox]="true"
                [toggleAllCheckboxChecked]="isSelectedAllType()"
                [toggleAllCheckboxIndeterminate]="isIndeterminateType()" ngDefaultControl ngModel
                noEntriesFoundLabel="No matching type found" placeholderLabel="Search Type...">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let item of filterTypeList" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
          <button (click)="resetType()" *ngIf="!isSelectedAllType()" class="clear-field-btn" mat-icon-button matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </mat-card>
  <mat-card class="card-table">
    <table (matSortChange)="sortChange($event)" [dataSource]="dataSource" mat-table matSort matSortActive="createdDate"
      matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="createdDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Submission Date</th>
        <td *matCellDef="let element; dataSource: dataSource" [copyValue]="
              element?.claimCreatedDate | date : 'dd MMM yyyy hh:mm aa' || ''
            " mat-cell>
          <div>
            {{ element?.claimCreatedDate | date : "dd MMM yyyy" || "-" }}
          </div>
          <div>
            {{ element?.claimCreatedDate | date : "hh:mm aa" || "-" }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="claimRefNo">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Claim Reference No.</th>
        <td *matCellDef="let element; dataSource: dataSource" [copyValue]="element?.claimRefNo || '-'" mat-cell
          style="max-width: 150px; padding-right: 8px">
          {{ element?.claimRefNo || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="UI_claimType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Claim Type</th>
        <td *matCellDef="let element; dataSource: dataSource" [copyValue]="element?.UI_claimType || ''" mat-cell>
          {{ element?.UI_claimType || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="UI_claimStatus">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Claim Status</th>
        <td *matCellDef="let element; dataSource: dataSource" mat-cell>
          <span *ngIf="element.UI_claimStatus" class="cover-label"
            [ngClass]="getClaimStatusCss(element.UI_claimStatus)">
            {{ element.UI_claimStatus }}
          </span>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="claimListColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: claimListColumns" mat-row></tr>

      <tr *matNoDataRow>
        <ng-container *ngIf="!isLoading && dataSource.length === 0" [ngTemplateOutletContext]="{
              recordText: 'claim list'
            }" [ngTemplateOutlet]="emptyRecordTemplate">
        </ng-container>
      </tr>
    </table>
  </mat-card>
</div>

<ng-template #emptyRecordTemplate let-recordText="recordText">
  <td class="mat-cell" colspan="9999">
    <div class="mv-lg" fxLayout="column" fxLayoutAlign="center center">
      <img alt="" src="https://i.ibb.co/RhqwZRK/no-record-found.png" />
      <div class="fs-lg color-muted">No {{ recordText }} found</div>
    </div>
    <ngx-skeleton-loader *ngIf="isLoading" [theme]="{
          height: '40px',
          'animation-duration': '1s'
        }" count="3">
    </ngx-skeleton-loader>
  </td>
</ng-template>